module.exports = __webpack_public_path__ + "img/related-post-02.f7e14cf2.jpg";